// extracted by mini-css-extract-plugin
export default {"wrapper":"reviews_wrapper__lsRbg","title":"reviews_title__xC4+D","reviews-wrapper":"reviews_reviews-wrapper__5V8eE"};